/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPmiCoordinateSystem = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12.505 15.157v1.484c-.392.205-.83.36-1.316.462a6.898 6.898 0 0 1-1.554.168c-1.568 0-2.772-.462-3.612-1.386-.83-.924-1.246-2.259-1.246-4.004 0-1.073.196-1.993.588-2.758a4.209 4.209 0 0 1 1.708-1.764c.747-.42 1.63-.63 2.646-.63.449 0 .892.051 1.33.154.44.103.817.247 1.135.434v1.47a8.726 8.726 0 0 0-1.274-.42 4.783 4.783 0 0 0-1.079-.126c-1.045 0-1.852.322-2.422.966-.569.635-.854 1.526-.854 2.674 0 1.241.28 2.198.84 2.87.57.663 1.382.994 2.436.994.411 0 .827-.047 1.247-.14a9.463 9.463 0 0 0 1.428-.448zm1.103 1.596v-1.386c.467.187.887.322 1.26.406a5.97 5.97 0 0 0 1.176.112c1 0 1.498-.285 1.498-.854a.624.624 0 0 0-.252-.518c-.158-.14-.438-.266-.84-.378l-1.091-.294c-.663-.187-1.149-.443-1.457-.77-.307-.336-.461-.765-.461-1.288 0-.69.265-1.232.797-1.624.533-.392 1.256-.588 2.17-.588.44 0 .864.037 1.274.112.411.075.761.177 1.05.308v1.358a6.271 6.271 0 0 0-2.253-.434c-.906 0-1.358.252-1.358.756 0 .196.079.36.237.49.16.121.425.233.799.336l1.091.308c.72.205 1.228.471 1.526.798.3.317.448.765.448 1.344 0 .737-.27 1.307-.812 1.708-.54.401-1.31.602-2.31.602-.457 0-.914-.047-1.372-.14-.457-.093-.83-.215-1.12-.364z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPmiCoordinateSystem as PmiCoordinateSystem };
